import { render, staticRenderFns } from "./NotificationCompanyDepartmentMemberDeleted.vue?vue&type=template&id=2f0d466e&scoped=true&lang=pug&"
import script from "./NotificationCompanyDepartmentMemberDeleted.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyDepartmentMemberDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d466e",
  null
  
)

export default component.exports